import { Table } from 'antd';
import { useStandard } from '../../hook/useHook';
export default function index(props: any) {
    const { columns, } = props
    const { getTableData } = useStandard()

    return (
        <Table
            columns={columns}
            scroll={{ x: 2400 }}
            style={{ marginTop: 20 }}
            {...getTableData.tableProps}
            pagination={{
                total: getTableData?.pagination?.total,
                showTotal: (total) => `共${getTableData?.pagination?.total}条`
            }}
        />
    );
}
